import * as actions from '../actionTypes/qnaActiontypes';

export const setQnaLoader = (_data: any) => {
    return {
        type: actions.SET_QNA_LOADER,
        payload: _data
    }
}

export const getQnaList = (data: any, _callback: any) => {
    return {
        type: actions.GET_QNA_LIST,
        payload: data,
        callback: _callback
    }
}

export const setQnaList = (_data: any) => {
    return {
        type: actions.SET_QNA_LIST,
        payload: _data
    }
}


export const addUpdateAnswer = (_data: any, _callback: any) => {
    return {
        type: actions.ADD_UPDATE_ANSWER,
        payload: _data,
        callback: _callback
    }
}

export const publishQuestions = (_data: any, _callback: any) => {
    return {
        type: actions.PUBLISH_QUESTIONS,
        payload: _data,
        callback: _callback
    }
}

export const disableQuestions = (_data: any, _callback: any) => {
    return {
        type: actions.DISABLE_QUESTIONS,
        payload: _data,
        callback: _callback
    }
}

export const downloadQuestions = (_data: any, _callback: any) => {
    return {
        type: actions.DOWNLOAD_QUESTIONS,
        payload: _data,
        callback: _callback
    }
}

// Action creator for bulk inserting Q&A via CSV file upload
export const bulkInsertQA = (_data: any, _callback: any) => {
    return {
        type: actions.BULK_INSERT_QA,
        payload: _data,
        callback: _callback
    }
}

// Action creator for bulk publishing Q&A via CSV of qIds
export const bulkPublishQA = (_data: any, _callback: any) => {
    return {
        type: actions.BULK_PUBLISH_QA,
        payload: _data,
        callback: _callback
    }
}
